import { cn } from '~/shadcn/lib/utils';

/**
 * Character counter component that displays current/maximum character count
 *
 * @param {Object} props
 * @param {number} props.currentCount - Current character count
 * @param {number} props.maxLength - Maximum allowed characters
 * @param {string} props.className - Additional CSS classes
 * @returns {JSX.Element|null} CharacterCounter component or null if no maxLength
 */
function CharacterCounter({ currentCount, maxLength, className = '' }) {
    // Don't render if maxLength is not provided
    if (!maxLength) {
        return null;
    }

    const isNearLimit = currentCount >= maxLength * 0.8;
    const isAtLimit = currentCount >= maxLength;

    return (
        <div className={cn('text-xs text-right', className)}>
            <span className={isAtLimit ? 'text-red-500 font-medium' : isNearLimit ? 'text-amber-600' : 'text-gray-500'}>
                {currentCount} / {maxLength}
            </span>
        </div>
    );
}

export default CharacterCounter;
